import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "../lib/api";
import Seo, { usePageSeo } from "../lib/seo";

export default function Practice() {
  const [items, setItems] = useState(null);
  const pageSeo = usePageSeo("practice");

  useEffect(() => {
    api.get("/practice").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <main data-testid="practice-page" className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-20 pt-40 md:pt-52 pb-16">
      <Seo title={pageSeo?.seo_title || "Practice — RCKT"}
        description={pageSeo?.seo_description || "The evolving documentation of RCKT as an artistic practice — its development, thinking, experiments, processes and encounters."}
        canonical={`${window.location.origin}/practice`} />
      <header className="border-b hairline pb-8 mb-14">
        <div className="label mb-6">Documentation</div>
        <h1 className="font-display font-800 uppercase leading-[0.9] tracking-[-0.02em] text-6xl md:text-8xl">Practice</h1>
        <p className="mt-8 text-[var(--muted)] max-w-xl">
          The evolving record of RCKT as a practice — its development, thinking, experiments, processes and encounters.
        </p>
      </header>

      {items === null ? (
        <div className="py-24 label">Loading…</div>
      ) : items.length === 0 ? (
        <div className="py-32 max-w-xl" data-testid="practice-empty">
          <div className="label mb-4">Nothing here yet</div>
          <p className="text-[var(--muted)] text-lg leading-relaxed">The practice is currently being documented. Return soon.</p>
        </div>
      ) : (
        <div className="divide-y" style={{ borderColor: "var(--line)" }}>
          {items.map((p, i) => (
            <motion.div key={p.slug} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: (i % 4) * 0.05 }}>
              <Link to={`/practice/${p.slug}`} data-testid={`practice-card-${p.slug}`} className="group grid grid-cols-1 md:grid-cols-12 gap-4 py-10 border-t hairline">
                <div className="md:col-span-2 label pt-1">{p.number || p.date}</div>
                <div className="md:col-span-8">
                  <h2 className="font-display font-600 text-2xl md:text-4xl tracking-[-0.01em] group-hover:opacity-60 transition-opacity">{p.title}</h2>
                  {p.subtitle && <p className="text-[var(--muted)] mt-3 max-w-2xl">{p.subtitle}</p>}
                  {p.category && <span className="label mt-4 inline-block">{p.category}</span>}
                </div>
                <div className="md:col-span-2 md:text-right label pt-1">{p.date}</div>
              </Link>
            </motion.div>
          ))}
        </div>
      )}
    </main>
  );
}
